import React, { useEffect, useState } from "react";
import firebase from "../../config/fbConfig";
import "firebase/storage";
import axios from 'axios';
import getPrimaryString from "../../scripts/getPrimaryString";
import Health from "./Health";
import { Link } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import Footer from "./Footer";

function getPDF(id) {
  return axios.get(`https://europe-west3-carpe-diem-calendar-9db19.cloudfunctions.net/createPDF?id=${id}`, {
    responseType: 'arraybuffer',
    headers: {
      'Accept': 'application/pdf'
    }
  }).then((response) => {
    const year = new Date().getFullYear();
    const month = new Date().getMonth();
    const blob = new Blob([response.data], {type: 'application/pdf'})
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = `carpe-diem-calendar-${month}-${year}.pdf`
    link.click()
  })
  .catch(err => console.log(err))
}

async function GetDesign(designId) {
  return await firebase
    .firestore()
    .collection("designs")
    .doc(designId)
    .get()
    .then(function (doc) {
      return doc.data();
    });
}

function Download(props) {
  const designId = props.match.params.id;
  const [design, setDesign] = useState({});
  const [clicked, setClicked] = useState(false);
  const colourString = getPrimaryString(design.primary);

  var buttonInnerText = clicked ? <PulseLoader color="#FFFFFF" loading /> : `Download ${colourString} PDF`;
  var designLength = Object.keys(design).length;
  
  const savePDF = () => {
    setClicked(true);
    getPDF(designId);
  }
  const styleObj = {
    'margin': 0,
    'backgroundColor': design.primary,
  }
  useEffect(() => {
    GetDesign(designId)
      .then((data) =>
        setDesign({
          primary: data.primary,
          secondary: data.secondary,
        })
      )
      .catch((error) => console.log(error));
  }, [clicked]);
  
  return designLength === 0 ? (
    <div>
        Loading...
        <br /><br />
        <small>If you have read this sentence. Try refreshing the page.</small>
    </div>
  ): (
    <div>
      <header>
        <h1>
          Enjoy your <Link to="/" id="home-link">Carpe Diem Calendar</Link>
        </h1>
      </header>
      <div className='copy' id="download">
  <button className="download-btn" style={styleObj} onClick={savePDF}>{buttonInnerText}</button>
        <Health />
      </div>
      <Footer />
    </div>
  );
}

export default Download;
